<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <TimeView class="time-app" :app="widget.object" />
  </div>
</template>

<script>
import TimeView from '@/components/apps/time/TimeView.vue';
import templateWidget from '@/components/templates/mixins/templateWidget';
import { simpleTypeMixin } from '@/helpers';

export default {
  name: 'TimeWidget',

  components: {
    TimeView,
  },

  mixins: [simpleTypeMixin, templateWidget],

  props: {
    widget: {
      type: Object,
      required: true,
    },
  },

  computed: {
    style() {
      return {
        ...this.defaultStyling(this.widget),
        overflow: 'hidden',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-item {
  position: absolute;
  overflow: hidden;
}
</style>
